import axios, {AxiosRequestConfig} from 'axios';
import {APPS_CONFIG_LAMBDA_URL} from '../../constants';
import {FetchPpcConfigFulfilledPayload} from './types';
import {ValidJoinServicesRequest, createAxiosError, getMockCurrentDate} from '../utils';
import {AxiosResponse, AxiosError} from '../types';
import {captureMessage} from '@sentry/gatsby';

export const fetchPPCData = async () => {
  const mockedCurrentDate = getMockCurrentDate();
  const options: AxiosRequestConfig = {
    validateStatus: ValidJoinServicesRequest,
    headers: mockedCurrentDate ? {'x-mock-current-date': mockedCurrentDate} : undefined
  };

  try {
    const res = await axios.get<{data: FetchPpcConfigFulfilledPayload}>(`${APPS_CONFIG_LAMBDA_URL}/ppc/iwhi`, options);
    const response: AxiosResponse<FetchPpcConfigFulfilledPayload> = {
      data: res.data.data,
      type: 'PpcConfig'
    };
    return response;
  } catch (error) {
    captureMessage(`[WJW9] - fetch ppc config error -- ${error.message}`, 'error');

    const response: AxiosResponse<AxiosError> = {
      data: createAxiosError(error, 'GET'),
      type: 'AxiosError'
    };
    return response;
  }
};
